
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"23","height":"23","rx":"11.5","fill":"#2D954C","stroke":"#FEFEFE","stroke-width":"2"}}),_c('path',{attrs:{"d":"M9.35 15.36L5.9 11.74l-1.17 1.23 4.62 4.85L19.27 7.4l-1.16-1.22-8.76 9.18z","fill":"#FEFEFE"}})])
          )
        }
      }
    